export default {
  startTime:"Thời gian bắt đầu",
  endTime:"Thời gian kết thúc",
  to:"đến",
  confirm:"Xác nhận để tiếp tục ",
  opertion:" Hoạt động?",
  enter:"Xác nhận",
  cancel:"Hủy",
  selectAll:"Chọn tất cả",
  sort:"Số sê-ri",
  upload:"Tải lên",
  imgUploading:"Đang Tải lên hình ảnh",
  imgLimit:"Chỉ hỗ trợ ảnh định dạng jpg, png, gif!",
  add:"Thêm",
  update:"Sửa đổi",
  drag:"Kéo tệp vào đây hoặc",
  clickUpload:"Nhấp để tải lên",
  downTemplate:"Tải xuống Mẫu",
  submit:"Đưa lên",
  write:"Xin điền vào",
  validate:"Xác thực dữ liệu",
  uploadFail:"Tải lên thất bại",
  uploadSuc:"Tải lên thành công",
  uploading:"Đang tải...."


};
